import { t } from "../../../i18n";
import type { ReportModel } from "../model";
import { coverText } from "../cover";
import { advisoryCoverTitle, advisoryLine, reportAdvisories } from "../advisories";

export function Cover({ m }: { m: ReportModel }): JSX.Element {
  const i = m.project.info;
  const allOk = m.walls.every((w) => w.result?.ok);
  const code = m.walls.find((w) => w.result)?.result?.designCode ?? "tbdy2018";
  const basis = code === "ec7" ? t("Hesap esasları: EN 1997-1 (Eurocode 7) kısmi katsayılı tasarım — EQU ve GEO kombinasyonları; EN 1998-5 statik-eşdeğer deprem etkisi (Mononobe-Okabe); klasik güvenlik katsayıları bilgi amaçlı.")
    : code === "us" ? t("Hesap esasları: IBC 2021 §1807.2 ve AASHTO LRFD §11.6 (ASD güvenlik katsayıları: devrilme/kayma 1,5, taşıma gücü 3); Coulomb / Mononobe-Okabe toprak basıncı (kh = 0,5·kmax).")
    : t("Hesap esasları: Türkiye Bina Deprem Yönetmeliği 2018 (TBDY 2018) §16.12 — İstinat Yapıları; Mononobe-Okabe statik-eşdeğer yöntemi; klasik güvenlik katsayıları (TS 7994).");
  const c = coverText(m);
  const adv = reportAdvisories(m.project, m.walls);
  /** Uyarılar bölümü kapalıysa (özel ayar) tüm maddeler kapakta; açıksa yalnız sonucu kesinleştirmeyen (warn) maddeler tam metin */
  const shown = m.settings.sections.warnings ? adv.filter((a) => a.severity === "warn") : adv;
  return (
    <div className="cover" data-cover>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "8mm" }}>
        {c.logoDataUrl ? <img src={c.logoDataUrl} alt="Logo" style={{ maxHeight: "22mm", maxWidth: "70mm" }} /> : <span />}
        {c.firm ? <div className="muted" style={{ fontSize: "9pt", textAlign: "right", whiteSpace: "pre-line" }} data-cover-firm>{[c.firm.name, c.firm.address, [c.firm.phone, c.firm.email].filter(Boolean).join(" · ")].filter(Boolean).join("\n")}</div> : null}
      </div>
      <p className="muted" style={{ fontSize: "10pt" }}>{c.subtitle}</p>
      <h1>{c.title}</h1>
      <p style={{ fontSize: "13pt", fontWeight: 600 }}>{i.name}</p>
      <table style={{ width: "70%" }}>
        <tbody>
          {c.docNo ? <tr><td>{t("Belge no")}</td><td>{c.docNo}</td></tr> : null}
          {i.city || i.district ? <tr><td>{t("Yer")}</td><td>{[i.district, i.city].filter(Boolean).join(" / ")}</td></tr> : null}
          {i.block || i.parcel ? <tr><td>{t("Ada / Parsel")}</td><td>{i.block ?? "—"} / {i.parcel ?? "—"}</td></tr> : null}
          {i.owner ? <tr><td>{t("İşveren")}</td><td>{i.owner}</td></tr> : null}
          <tr><td>{t("Tarih")}</td><td>{i.date}</td></tr>
          <tr><td>{t("Revizyon")}</td><td>{i.revision}</td></tr>
          <tr><td>{t("Duvar sayısı")}</td><td>{m.walls.length}</td></tr>
          <tr><td>{t("Genel hüküm")}</td><td className={allOk ? "ok" : "bad"}>{allOk ? t("TÜM DUVARLAR SAĞLIYOR") : t("SAĞLANMAYAN KONTROL VAR")}</td></tr>
        </tbody>
      </table>
      {adv.length ? (
        <div className="advisory-box" data-cover-advisories>
          <strong>{advisoryCoverTitle(adv.length)}</strong>
          {shown.map((a) => <p key={a.id}>{advisoryLine(a)}</p>)}
        </div>
      ) : null}
      <p className="muted" style={{ fontSize: "9.5pt" }}>{basis}</p>
      {c.note ? <p style={{ fontSize: "9.5pt", whiteSpace: "pre-line" }} data-cover-note>{c.note}</p> : null}
      <div className="spacer" />
      {c.showSignatures ? (
        <div className="sign-grid">
          <div className="sign-box">{t("Proje müellifi")}<br />{i.engineer?.name ?? ""}{i.engineer?.chamberNo ? ` — Oda sicil no: ${i.engineer.chamberNo}` : ""}<br /><br />{t("İmza / kaşe")}</div>
          <div className="sign-box">{t("Kontrol eden kurum")}<br />{c.reviewer ?? ""}<br /><br />{t("İmza / kaşe")}</div>
        </div>
      ) : null}
    </div>
  );
}
